import React from 'react';
import cx from 'classnames';

import {Container} from 'reactstrap';

import styles from './Section.module.scss';

function Section(props) {
  const {
    children,
    className,
    light,
    grid,
    circle,
    circleLight,
    padded,
    gradient,
    ...rest
  } = props;

  return (
    <div
      className={cx(
        styles['section'],
        {
          [styles['section--light']]: light && !grid,
          [styles['section--grid']]: !light && grid,
          [styles['section--grid-light']]: light && grid,
          [styles['section--circle']]: circle,
          [styles['section--padded']]: padded,
          [styles['section--gradient']]: gradient,
          [styles['section--circle-light']]: circleLight,
        },
        className
      )}
      {...rest}
    >
      <Container className={styles['section--container']}>{children}</Container>
    </div>
  );
}

Section.defaultProps = {
  light: false,
  grid: false,
};

export default Section;
